// extracted by mini-css-extract-plugin
export var icon = "_5y-1";
export var subtext = "_5y-0";